import api from './api';
import { ApiResponse } from '../types';

export interface MatrixCellScoreRequest {
  rowLabel: string;
  columnOptionId: number;
  score: number;
}

export interface MatrixCellScoreResponse {
  id: number;
  questionId: number;
  rowLabel: string;
  columnOptionId: number;
  columnOptionContent: string;
  score: number;
}

export const matrixScoreService = {
  /**
   * Set batch cell scores for a matrix question
   */
  setBatchCellScores: async (
    questionId: number,
    requests: MatrixCellScoreRequest[]
  ): Promise<MatrixCellScoreResponse[]> => {
    const response = await api.put<ApiResponse<MatrixCellScoreResponse[]>>(
      `/admin/questions/${questionId}/matrix-scores`,
      requests
    );
    return response.data.data;
  },

  /**
   * Get cell scores for a matrix question
   */
  getCellScores: async (questionId: number): Promise<MatrixCellScoreResponse[]> => {
    const response = await api.get<ApiResponse<MatrixCellScoreResponse[]>>(
      `/admin/questions/${questionId}/matrix-scores`
    );
    return response.data.data;
  },
};
